import React from 'react'
import { Dialog, DialogContent, DialogFooter } from '@/components/ui/dialog'
import { useNavigate } from 'react-router-dom'
import {
    CreateSurveyButton,
    SecondaryButton,
} from '@/features/survey-builder/Tabs/CustomButton'
import Confetti from 'react-confetti'
import { setCreateModal } from '@/store/slices/surveySlice'
import { useDispatch } from 'react-redux'

interface PlanUpgradeSuccessModalProps {
    open: boolean
    onOpenChange: (open: boolean) => void
}

const features = [
    'Create unlimited surveys',
    'Customize your target audience',
    'Add survey to your Shopify Store',
    'Get advanced insights',
]

export const PlanUpgradeSuccessModal: React.FC<
    PlanUpgradeSuccessModalProps
> = ({ open, onOpenChange }) => {
    const dispatch = useDispatch()

    const handleClose = () => {
        onOpenChange(false)
    }

    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            {open && (
                <div className="absolute top-0 left-0 w-screen h-screen z-[100]">
                    <Confetti
                        width={window.innerWidth}
                        height={window.innerHeight}
                        confettiSource={{
                            x: window.innerWidth / 2 - 320,
                            y: window.innerHeight / 2 - 200,
                            w: 640,
                            h: 100,
                        }}
                        recycle={false}
                        numberOfPieces={200}
                        gravity={0.1}
                        initialVelocityX={0}
                        initialVelocityY={0}
                    />
                </div>
            )}
            <DialogContent className="max-w-[640px] p-0 py-6 pb-4 gap-0">
                <div className="px-6">
                    <h2 className="text-[20px] font-[650]">
                        You’re on the Pro Plan
                        <span role="img" aria-label="party">
                            🥳
                        </span>
                    </h2>
                    <p className="text-[13px] font-[400] text-[#616161]">
                        You’ve unlocked advanced features for your store
                    </p>
                </div>
                <div className="flex flex-col md:flex-row items-center gap-4 my-8 px-6">
                    {/* Video Section */}
                    <div className="relative w-[282px] h-[160px] flex flex-col items-center aspect-video rounded-md overflow-hidden border-none">
                        <iframe
                            width="282"
                            height="160"
                            src="https://www.youtube.com/embed/ccE0YdwOAQk?si=RRtT7kFmBXZCqR0M"
                            title="YouTube video player"
                            frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            referrerPolicy="strict-origin-when-cross-origin"
                            allowFullScreen
                            className="rounded-md"
                        ></iframe>
                    </div>
                    {/* Info Section */}
                    <div className="flex gap-6 items-center">
                        <div className="flex flex-col gap-6">
                            <ul className="space-y-4 ">
                                {features.map((feature, idx) => (
                                    <li
                                        key={feature}
                                        className="flex items-center justify-start gap-[10px]"
                                    >
                                        <span className="h-[24px] min-w-[24px] bg-[#E8DAFF] text-[#5D00D6] font-[450] rounded-full flex items-center justify-center text-[12px]">
                                            {idx + 1}
                                        </span>
                                        <div className="font-[550] text-[14px] whitespace-nowrap text-[#4A4A4A]">
                                            {feature}
                                        </div>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>
                </div>
                <DialogFooter className="px-4 border-t border-[#E3E3E3] pt-3">
                    <div className="flex gap-3">
                        <SecondaryButton text="Close" onClick={handleClose} />
                        <CreateSurveyButton
                            text="Create Survey"
                            onClick={() => {
                                onOpenChange(false)
                                dispatch(setCreateModal('create'))
                            }}
                        />
                    </div>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    )
}
